import AdminSettingsLayout from "@/layouts/AdminSettingsLayout.vue";

export default {
  path: 'settings',
  redirect: '/dashboard/settings/general',
  component: AdminSettingsLayout,
  children: [
    {
      path: 'general',
      name: 'general-settings',
      component: () => import('@/views/dashboard/settings/general.vue'),
      meta: { title: 'General Settings', auth: true }
    },
    {
      path: 'integrations',
      name: 'integrations-settings',
      component: () => import('@/views/dashboard/settings/integrations.vue'),
      meta: { title: 'Integrations', auth: true }
    },
    {
      path: 'aml-screening',
      name: 'aml-screening-settings',
      component: () => import('@/views/dashboard/settings/aml-screening.vue'),
      meta: { title: 'AML Screening', auth: true },
    },
    {
      path: 'departments',
      name: 'departments-settings',
      component: () => import('@/views/dashboard/settings/departments.vue'),
      meta: { title: 'Departments Settings', auth: true }
    },
    {
      path: 'blogs',
      name: 'blogs-settings',
      component: () => import('@/views/dashboard/settings/blogs.vue'),
      meta: { title: 'Blogs Settings', auth: true }
    },
    {
      path: 'blog-categories',
      name: 'blog-categories-settings',
      component: () => import('@/views/dashboard/settings/blog-categories.vue'),
      meta: { title: 'Blog Categories Settings', auth: true }
    },
    {
      path: 'countries',
      name: 'countries-settings',
      component: () => import('@/views/dashboard/settings/countries.vue'),
      meta: { title: 'Countries Settings', auth: true }
    },
    {
      path: 'permissions',
      name: 'permissions-settings',
      component: () => import('@/views/dashboard/settings/permissions.vue'),
      meta: { title: 'Permissions Settings', auth: true }
    },
    {
      path: 'role-visibility',
      name: 'role-visibility-settings',
      component: () => import('@/views/dashboard/settings/role-visibility.vue'),
      meta: { title: 'Role Visibility', auth: true }
    },
    {
      path: 'policy-types',
      name: 'policy-types-settings',
      component: () => import('@/views/dashboard/settings/policy-types.vue'),
      meta: { title: 'Policy Types', auth: true }
    },
    {
      path: 'alert-types',
      name: 'alert-types-settings',
      component: () => import('@/views/dashboard/settings/alert-types.vue'),
      meta: { title: 'Alert Types', auth: true }
    },
    {
      path: 'modules',
      name: 'modules-settings',
      component: () => import('@/views/dashboard/settings/modules.vue'),
      meta: { title: 'Modules Settings', auth: true }
    },
    {
      path: 'question-duplicates',
      name: 'question-duplicates-settings',
      component: () => import('@/views/dashboard/settings/question-duplicates.vue'),
      meta: {
        title: 'Question Duplicates',
        auth: true,
      }
    },
    {
      path: 'form-templates',
      meta: { title: 'Form Templates', auth: true },
      children: [
        {
          path: '',
          name: 'form-templates-settings',
          component: () => import('@/views/dashboard/settings/form-templates/index.vue'),
          meta: {
            title: 'Form Templates',
            pageTitle: 'Form Templates',
            auth: true,
            permissions: { any: ['admin'] },
          },
        },
        {
          path: 'add',
          name: 'form-templates-add',
          component: () => import('@/views/dashboard/settings/form-templates/add.vue'),
          meta: {
            title: 'Create Form Template',
            pageTitle: 'Create Form Template',
            auth: true,
            permissions: { any: ['admin'] },
          },
        },
        {
          path: ':id',
          name: 'form-templates-edit',
          component: () => import('@/views/dashboard/settings/form-templates/add.vue'),
          meta: {
            title: 'Edit Form Template',
            pageTitle: 'Edit Form Template',
            auth: true,
            permissions: { any: ['admin'] },
          },
        },
      ],
    },
    {
      path: 'training-templates',
      meta: { title: 'Training Templates', auth: true },
      children: [
        {
          path: '',
          name: 'training-templates-settings',
          component: () => import('@/views/dashboard/settings/training-templates/index.vue'),
          meta: {
            title: 'Training Templates',
            pageTitle: 'Training Templates',
            auth: true,
            permissions: { any: ['admin'] },
          },
        },
        {
          path: ':id',
          name: 'training-templates-settings-details',
          component: () => import('@/views/dashboard/settings/training-templates/_id.vue'),
          meta: {
            title: 'Training Template',
            pageTitle: 'Training Template',
            auth: true,
            permissions: { any: ['admin'] },
          },
        },
      ],
    },
    {
      path: 'feedbacks',
      meta: { title: 'Feedbacks', auth: true },
      children: [
        {
          path: '',
          name: 'feedbacks-settings',
          component: () => import('@/views/dashboard/settings/feedbacks/index.vue'),
          meta: {
            title: 'Feedbacks',
            pageTitle: 'Feedbacks',
            auth: true,
            permissions: { any: ['admin'] },
          },
        },
        {
          path: ':feedback_id',
          name: 'feedback-details-settings',
          component: () => import('@/views/dashboard/settings/feedbacks/_id.vue'),
          meta: {
            title: 'Feedback Details',
            auth: true,
            permissions: { any: ['admin'] },
          },
        },
      ],
    },
  ],

}